import { render, staticRenderFns } from "./UploadButton.vue?vue&type=template&id=00c950f3&scoped=true&"
import script from "./UploadButton.vue?vue&type=script&lang=js&"
export * from "./UploadButton.vue?vue&type=script&lang=js&"
import style0 from "./UploadButton.vue?vue&type=style&index=0&id=00c950f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c950f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
